<template>
  <div class="calendar-arrow calendar-arrow-input">
    <div class="input-month">
      <button ref="prevBtn" :disabled="!hasPrevMonth" @click.prevent="prevMonth">
        <i class="icon-chevron-left" aria-hidden="true"></i>
      </button>
      <span class="month-name">{{tc(`calendar.months.${currentMonthIndex}`)}} {{ currentYear }}</span>
      <button ref="nextBtn" :disabled="!hasNextMonth" @click.prevent="nextMonth">
        <i class="icon-chevron-right" aria-hidden="true"></i>
      </button>

    </div>
    <div class="calendar-arrow-header-days">
      <span
        v-for="week in [7, 1, 2, 3, 4, 5, 6]"
        :key="week"
        class="week-short"
      >
        {{ tc(`calendar.daysMobile.${week}`) }}
      </span>
    </div>
    <div class="month-wrapper">
      <transition :name="`gallery-slide-${transitionDirection}`">
        <calendar-input-month
          :key="currentMonth"
          :month="currentMonth"
          :selected-date="selectedDate"
          :current-focus="currentFocus"
          @refresh-focusable="changeFocusable"
        />
      </transition>
    </div>
    <div class="input-cta">
      <button :disabled="!selectedDate" @click.prevent="$emit('input', selectedDate)">{{tc('calendar.doneLabel')}}</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getDate } from '@utils/date-helpers'
import TabTrapMixin from '@mixins/tab-trap'
import CalendarInputMonth from './calendar-input-month.vue'
export default {
  name: 'calendar-input',
  components: {
    CalendarInputMonth
  },
  mixins: [TabTrapMixin],
  props: {
    value: {
      type: [Date, String],
    },
    startDate: {
      type: [String, Date],
      required: true
    },
    endDate: {
      type: [String, Date]
    },
    disabledDates: {
      type: Array,
      default: () => []
    },
    disabledWeekDates: {
      type: Array,
      default: () => []
    },
    lang: {
      type: Object
    }
  },
  provide() {
    return {
      selectDate: this.selectDate,
      startDate: this.startDate,
      endDate: this.endDate,
      disabledDates: this.disabledDates,
      disabledWeekDates: this.disabledWeekDates,
    }
  },
  data: () => ({
    selectedDate: null,
    currentMonth: null,
    currentFocus: null,
    transitionDirection: 'right'
  }),
  computed: {
    ...mapGetters('booking', ['monthFormat', 'dayFormat']),
    ...mapGetters('i18n', ['tc']),
    firstDay() {
      return this.selectedDate || this.startDate
    },
    firstDayInDate() {
      return getDate(this.firstDay, this.dayFormat)
    },
    startMonth() {
      return this.firstDayInDate.format(this.monthFormat)
    },
    currentMonthInDate() {
      return getDate(this.currentMonth, this.monthFormat)
    },
    currentMonthIndex() {
      return this.currentMonthInDate.month() + 1
    },
    currentYear() {
      return this.currentMonthInDate.year()
    },
    hasPrevMonth() {
      return !this.startDate || getDate(this.startDate, this.dayFormat).isBefore(getDate(this.currentMonth, this.monthFormat), 'month')
    },
    hasNextMonth() {
      return !this.endDate || getDate(this.endDate, this.dayFormat).isAfter(getDate(this.currentMonth, this.monthFormat), 'month')
    }
  },
  watch: {
    value(val) {
      if (this.selectedDate !== val) {
        this.selectedDate = val
      }
    },
    hasPrevMonth(val) {
      if (!val) {
        this.$refs.nextBtn.focus()
      }
    },
    hasNextMonth(val) {
      if (!val) {
        this.$refs.prevBtn.focus()
      }
    }
  },
  async created() {
    this.selectedDate = this.value
    this.currentMonth = this.startMonth
    if (this.lang) {
      await this.registerScopedLang({ scope: 'calendar', lang: this.lang })
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementsByTagName('body')[0].addEventListener('click', this.closeModal)
      this.$el.addEventListener('click', this.prevent)
    }, 100)
  },
  destroyed() {
    document.getElementsByTagName('body')[0].removeEventListener('click', this.closeModal)
      this.$el.removeEventListener('click', this.prevent)
  },
  methods: {
    ...mapActions('i18n', ['registerScopedLang']),
    selectDate(date) {
      this.selectedDate = date
    },
    prevMonth() {
      this.transitionDirection = 'right'
      const prevMonth = getDate(this.currentMonth, this.monthFormat).subtract(1, 'month')
      this.currentMonth = prevMonth.format(this.monthFormat)
    },
    nextMonth() {
      this.transitionDirection = 'left'
      const nexMonth = getDate(this.currentMonth, this.monthFormat).add(1, 'month')
      this.currentMonth = nexMonth.format(this.monthFormat)
    },
    closeModal() {
      console.log('close modal')
      this.$emit('close')
    },
    prevent(e) {
      e.stopPropagation()
    },
    changeFocusable(elementId) {
      this.currentFocus = elementId
      this.$nextTick(() => {
        this.getFocusableElements()
      })
    }
  }
}
</script>
